import React from 'react';
import { Button } from 'react-bootstrap';
import BodyRegular from 'components/Typography/BodyRegular';
import './index.scss';

export default function RoundTabButton({
  onClick,
  text,
  active,
}: {
  onClick: () => void;
  text: string;
  active: boolean;
}) {
  return (
    <Button
      className="discrete-nav-link"
      variant="link"
      active={active}
      onClick={onClick}
    >
      <BodyRegular>
        {text}
      </BodyRegular>
    </Button>
  );
}
